import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from "src/environments/environment";
import { Observable, retry } from 'rxjs';
import { Router } from '@angular/router';

const DEFAULT_OPTIONS = {
  httpOptions: {
        headers: new HttpHeaders().set('Content-Type', 'application/json'),
        withCredentials: true,
        params:{}
      }
}

export class ApiOptions {
  method:'GET' | 'POST' | 'PUT' | 'DELETE' | undefined;
  relativeUrl:string | undefined;
  body:any;
  options:any;
}
@Injectable({
  providedIn: 'root'
})
export class ApiRequestService {
  private baseUrl: string = environment.apiUrl;
  constructor(
    private http: HttpClient,
    private router: Router,
  ) { }


  public request(method: ApiOptions['method'],relativeUrl:ApiOptions['relativeUrl'],body?:any,option?:any) {
    let options:any = {};
    options['method'] = method; 
    options['relativeUrl'] = relativeUrl; 
    options['body'] = body ? body : {}; 
    options['options'] = option ? option : {}; 
    //This Function will Always return an Observale with api response(Result or error) and call actual http request function
    return new Observable((subscriber) => {
      this.httpCall(options, (response:any) => {
        subscriber.next(response);
        subscriber.complete();
      });
    });
  }


  private httpCall(options:ApiOptions, cb:any) {
    //This function will execute actual api request 
    // let method = options.method.toLowerCase() as string;
    let reqArray = this.apiRequestData(options)
    switch (options.method) {
      case 'POST':
        this.postRequest(reqArray,cb)
        break;
      case 'PUT':
        this.putRequest(reqArray,cb)
        break;
      case 'GET':
        this.getRequest(reqArray,cb)
        break;
      case 'DELETE':
        this.deleteRequest(reqArray,cb)
        break;
      default:
        console.log("Request method is not recognized")
        break;
    }

  }

  private handleError(error:any, cb:any) {
    console.log('Error On API Hit',error);
    this.router.navigate(["/user/login"]);
    if (error.status == 403) {
      this.logout();
    }
    // console.log("*****************")
    cb(error);
  }

  logout() {
    localStorage.removeItem('access');
    this.router.navigate(['/auth/login'], {
      queryParams: {},
    });
  }

  private apiRequestData(options:ApiOptions) {
    //This function will set all params within http call
    //If method is not post or put, it will not send body object to the api
    let arr = [];

    //Below function will return absolute url to be requested for api
    //If baseUrl are not sent in options object this function will take default baseUrl
    let url = this.getURL(options.options, options.relativeUrl);
    arr.push(url);

    if(options.method == 'POST' || options.method == 'PUT') {
      arr.push(options.body);
    }

    // Reinitialize DEFAULT_OPTIONS.httpOptions to make sure it's not containing old request headers.
    let headers = new HttpHeaders({
      'Content-Type':'application/json; charset=utf-8',
    });
    // DEFAULT_OPTIONS.httpOptions = {
    //   headers: new HttpHeaders().set('Content-Type', 'application/json'),
    //   withCredentials: true,
    //   params:{}
    // }

    DEFAULT_OPTIONS.httpOptions = {
      headers: headers,
      withCredentials: true,
      params:{}
    }

    //Below function will set http options with headers data
    //If httpOptions are sent in options object, the below function will set to that else it will execute default httpoptions
    let httpOption = this.getHeaders(options.options);
    arr.push(httpOption);
   
    return arr;
  }

  private getHeaders(options:any) {
    let httpOptions = options.httpOptions ? options.httpOptions : DEFAULT_OPTIONS.httpOptions;
    if(options.query) {
      httpOptions.params = options.query;
    }
    return httpOptions;
  }

  private getURL(options: any, relativeUrl: ApiOptions['relativeUrl']) {
    if (options.baseUrl) {
      return options.baseUrl+relativeUrl;
    }
    return this.baseUrl+relativeUrl;
  }

  getRequest(reqArray:any, cb:any){
    this.http.get(reqArray[0],reqArray[1])
      .pipe(
        retry(3)
        // timeout(options.options.timeout | 30000)
        )
      .subscribe({
        next : (response) =>{
          cb(response);
        },
        error: (error) =>{
          this.handleError(error, cb);
        },
        complete: () => console.info('complete') 
      });
  }

  putRequest(reqArray:any, cb:any){
    this.http.put(reqArray[0],reqArray[1],reqArray[2])
      .pipe(
        retry(3)
        // timeout(options.options.timeout | 30000)
        )
      .subscribe({
        next : (response) =>{
          cb(response);
        },
        error: (error) =>{
          this.handleError(error, cb);
        },
        complete: () => console.info('complete') 
      });
  }

  postRequest(reqArray:any, cb:any){
    this.http.post(reqArray[0],reqArray[1],reqArray[2])
      .pipe(
        retry(3)
        // timeout(options.options.timeout | 30000)
        )
      .subscribe({
        next : (response) =>{
          cb(response);
        },
        error: (error) =>{
          this.handleError(error, cb);
        },
        complete: () => console.info('complete') 
      });
  }

  deleteRequest(reqArray:any, cb:any){
    this.http.delete(reqArray[0],reqArray[1])
      .pipe(
        retry(3)
        // timeout(options.options.timeout | 30000)
        )
      .subscribe({
        next : (response) =>{
          cb(response);
        },
        error: (error) =>{
          this.handleError(error, cb);
        },
        complete: () => console.info('complete') 
      });
  }
}
